import React, { FC, useEffect } from 'react';
import { IReduxFinanceQuote } from '../../../../redux/financeWidget/financeWidget.duck.interface';
import FinanceWidgetDuck from '../../../../redux/financeWidget/financeWidget.duck';
import { connect } from 'react-redux';
import { NETWORK_STATUS_ERROR, NETWORK_STATUS_START, Redux } from '../../../../redux/redux.interface';
import Spinner from '../../../Spinner';
import { theme } from '../../../../styles/theme';
import { useMoneyFormatter } from '@hooks/useMoneyFormatter';
import useTranslations from '@hooks/useTranslations';
import { IConfigurableCar } from '../../../../interfaces/Car';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../../../../context/featureSwitchApp';
import { getMonthlyPriceObjByType } from '@utils/Price.utils';
import { StockFormatedPriceType } from '../../../../services/stock/models/stockItem.price.model';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';

interface IDealFinancePrice {
    id: string;
    actionFetchFinanceQuoteToList: (id: string) => void;
    financeQuoteList: IReduxFinanceQuote[];
    fullProductConfiguration: IConfigurableCar;
    dealerId?: string;
}

const DealFinancePrice: FC<IDealFinancePrice> = ({
    id,
    actionFetchFinanceQuoteToList,
    financeQuoteList,
    fullProductConfiguration,
    dealerId,
}: IDealFinancePrice) => {
    const reduxFinanceQuote = financeQuoteList.find((financeQuote: IReduxFinanceQuote) => financeQuote.id === id);
    const { formatMoney } = useMoneyFormatter();
    const { t } = useTranslations();
    const { carDetails } = useCarDetailsDuck();
    const isSOLEnabled = useFeatureSwitchEnabled(FEATURES_LIST.FEATURE_SWITCH_SOL_ENABLED);
    const amountRounding = getMonthlyPriceObjByType(carDetails.prices, StockFormatedPriceType.EMPLOYEE)?.amountRounding;
    useEffect(() => {
        if (!reduxFinanceQuote) {
            actionFetchFinanceQuoteToList(id);
        }
    }, [actionFetchFinanceQuoteToList, id, reduxFinanceQuote]);

    if (!reduxFinanceQuote || reduxFinanceQuote.status === NETWORK_STATUS_START) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Spinner size={20} border={3} color={theme.colors.grey10} />
            </div>
        );
    }

    if (reduxFinanceQuote.status === NETWORK_STATUS_ERROR) {
        return <div>FAILED TO LOAD FINANCE QUOTE</div>;
    }

    return (
        <span className="price" data-testid={id ? `TESTING_TOTAL_PRICE_${id}` : 'TESTING_TOTAL_PRICE'}>
            {formatMoney(reduxFinanceQuote.financeQuote.monthlyPayment, false, '', amountRounding)}
            <span className="monthly-price-suffix">{t('dealPreview.dealFinancePrice.monthlySuffix')}</span>
        </span>
    );
};

const mapStateToProps = (state: Redux) => ({
    financeQuoteList: FinanceWidgetDuck.getOwnState(state).financeQuoteList,
});

const mapDispatchToProps = {
    actionFetchFinanceQuoteToList: FinanceWidgetDuck.actionFetchFinanceQuoteToList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealFinancePrice);
